import { render } from "./ApplyMetadataRelation.vue?vue&type=template&id=6ba1b674&ts=true"
import script from "./ApplyMetadataRelation.vue?vue&type=script&lang=ts"
export * from "./ApplyMetadataRelation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__